module.exports = __webpack_public_path__ + "frontend/images/signpost/white.jpg?6be1ff2e35eb4666793e42d7bb1b7ad1";